/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ProblemDetails,
  ProjectBlobStatistics,
  ProjectInfo,
  ProjectState,
  ProjectToAddInfo,
  ProjectToUpdateInfo,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Project
   * @summary Получить все не удалённые проекты доступные для пользователя.
   * @request GET:/project/Project
   * @secure
   */
  projectGetAllProjects = (params: RequestParams = {}) =>
    this.http.request<ProjectInfo[], ProblemDetails>({
      path: `/project/Project`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Добавить новый приватный проект.
   * @request POST:/project/Project
   * @secure
   */
  projectAddProject = (data: ProjectToAddInfo, params: RequestParams = {}) =>
    this.http.request<string, ProblemDetails>({
      path: `/project/Project`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Изменить существующий проект, не меняя его статус.
   * @request PUT:/project/Project
   * @secure
   */
  projectUpdateProject = (data: ProjectToUpdateInfo, params: RequestParams = {}) =>
    this.http.request<boolean, ProblemDetails>({
      path: `/project/Project`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Удалить существующий проект
   * @request DELETE:/project/Project
   * @secure
   */
  projectDeleteProject = (
    query: {
      /**
       * Идентификатор проекта.
       * @format uuid
       */
      projectId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ProblemDetails>({
      path: `/project/Project`,
      method: 'DELETE',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Получить не удалённый проект, доступный пользователю по идентификатору проекта.
   * @request GET:/project/Project/{projectId}
   * @secure
   */
  projectGetProjectById = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectInfo, ProblemDetails>({
      path: `/project/Project/${projectId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Project
 * @summary Изменить статус проекта.
Если статус становится публичным, то добавить опубликованный проект во все группы доступа пользователя. 
Если статус становится приватным, то убрать проект из всех связанных групп доступа, назначить пользователя владельцем проекта.
 * @request PUT:/project/Project/{projectId}/SetState/{projectState}
 * @secure
 */
  projectSetProjectState = (
    projectId: string,
    projectState: ProjectState,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, ProblemDetails>({
      path: `/project/Project/${projectId}/SetState/${projectState}`,
      method: 'PUT',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Получить группы доступа для опубликованного проекта.
   * @request GET:/project/Project/{projectId}/GetProjectAccessGroups
   * @secure
   */
  projectGetProjectAccessGroups = (projectId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/project/Project/${projectId}/GetProjectAccessGroups`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Project
 * @summary Добавить опубликованный проект в группы доступа. 
Пользователь-инициатор должен входить во все перечисленные группы.
 * @request POST:/project/Project/{projectId}/AddToAccessGroups
 * @secure
 */
  projectAddToAccessGroups = (projectId: string, data: string[], params: RequestParams = {}) =>
    this.http.request<boolean, ProblemDetails>({
      path: `/project/Project/${projectId}/AddToAccessGroups`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Удалить опубликованный проект из групп доступа.
   * @request POST:/project/Project/{projectId}/RemoveFromAccessGroups
   * @secure
   */
  projectRemoveFromAccessGroups = (projectId: string, data: string[], params: RequestParams = {}) =>
    this.http.request<boolean, ProblemDetails>({
      path: `/project/Project/${projectId}/RemoveFromAccessGroups`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Получить список типов проектов.
   * @request GET:/project/Project/ProjectTypes
   * @secure
   */
  projectGetProjectTypes = (params: RequestParams = {}) =>
    this.http.request<Record<string, string>, any>({
      path: `/project/Project/ProjectTypes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Получить список статусов проектов.
   * @request GET:/project/Project/ProjectStates
   * @secure
   */
  projectGetProjectStates = (params: RequestParams = {}) =>
    this.http.request<Record<string, string>, any>({
      path: `/project/Project/ProjectStates`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Project
   * @summary Получить список типов доменов.
   * @request GET:/project/Project/DomainTypes
   * @secure
   */
  projectGetDomainTypes = (params: RequestParams = {}) =>
    this.http.request<Record<string, string>, any>({
      path: `/project/Project/DomainTypes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
 * No description
 * 
 * @tags Project
 * @summary Получить cтатистику хранения двоичных объектов проекта в базе данных,
в том числе по удалённым. Не требует авторизации.
 * @request GET:/project/Project/{projectId}/ProjectBlobStat
 * @secure
 */
  projectGetProjectBlobStat = (projectId: string, params: RequestParams = {}) =>
    this.http.request<ProjectBlobStatistics, any>({
      path: `/project/Project/${projectId}/ProjectBlobStat`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
